import * as React from "react";
import { SVGProps } from "react";
export function GripVerticalIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={14}
      height={14}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#grip-vertical_svg__a)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx={5.25} cy={3.208} r={0.583} />
        <circle cx={5.25} cy={7} r={0.583} />
        <circle cx={5.25} cy={10.792} r={0.583} />
        <circle cx={8.75} cy={3.208} r={0.583} />
        <circle cx={8.75} cy={7} r={0.583} />
        <circle cx={8.75} cy={10.792} r={0.583} />
      </g>
      <defs>
        <clipPath id="grip-vertical_svg__a">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
